<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import removeEvent from '@cclib/functions/eventGroups/removeEvent.js';
import * as m from '@app/paraglide/messages.js';

function removeEvents() {
    eventGroupState[projectState.selected].selected.sort((a, b) => {
        return b - a;
    });

    let lastEvent = eventGroupState[projectState.selected].selected[eventGroupState[projectState.selected].selected.length-1]-1;

    eventGroupState[projectState.selected].selected.forEach(eventIndex => {
        eventGroupState[projectState.selected] = removeEvent(eventGroupState[projectState.selected], eventIndex);
    });

      eventGroupState[projectState.selected].selected = lastEvent >= 0 ? [lastEvent] : [];

    // Dispatch custom event to scroll to the selected event if one exists
    if (eventGroupState[projectState.selected].selected[0] !== undefined) {
        const selectedIndex = eventGroupState[projectState.selected].selected[0];
        window.dispatchEvent(new CustomEvent('scrollToVirtualListItem', {
            detail: { index: selectedIndex }
        }));
    }

    insertHistoryAction({
        name: "remove event(s)", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });
}
</script>
<li 
    title={m.remove_event_title()}
    class="nav-item"
    role="none"
    class:disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}>
    <a class="nav-link"
       href="#!/"
       role="button"
       id="remove-events-btn"
       aria-label={m.remove_event_aria_label()}
       aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}
       onclick={removeEvents}>
        <i class="bi bi-trash" aria-hidden="true"></i>
    </a>
</li>
